<template>

    <div id="nav">

        <b-nav vertical class="d-none d-lg-block">
            <b-nav-item to="/">Hjem</b-nav-item>

            <b-nav-item to="/bruksoversikt">Bruksoversikt</b-nav-item>
            <b-nav-item to="/overforing">Sett inn penger</b-nav-item>
            <b-nav-item to="/utbetaling">Ta ut penger</b-nav-item>
            
            <b-nav-item to="/blokkeringsoversikt">Pause og Blokkering</b-nav-item>
            <b-nav-item to="/pause">Ta pause ifra spill</b-nav-item>
            <b-nav-item to="/blokker">Blokker deg for spill</b-nav-item>
            
            <b-nav-item to="/medlemskort">Medlemskort</b-nav-item>
            <b-nav-item to="/nytt-kort">Nytt kort</b-nav-item>
            <b-nav-item to="/min-side">Innstillinger</b-nav-item>

            <b-nav-item @click="handleLogout()">Logg ut</b-nav-item>

            <!-- <b-nav-item to="/transaksjoner">Transaksjoner</b-nav-item> -->
            <!-- <b-nav-item to="/spillhaller" v-if="!$store.getUser().blocked">Spillhaller</b-nav-item> -->
        </b-nav>

        <b-nav class="d-lg-none justify-content-center">
            <b-nav-item to="/">Hjem</b-nav-item>

            <b-nav-item to="/bruksoversikt">Bruksoversikt</b-nav-item>
            <b-nav-item to="/overforing">Sett inn</b-nav-item>

            <b-nav-item to="/medlemskort">Kort</b-nav-item>
            <b-nav-item to="/nytt-kort">Nytt kort</b-nav-item>
            <b-nav-item to="/min-side">Innstillinger</b-nav-item>

            <b-nav-item to="/spillhaller">Spill</b-nav-item>

            <b-nav-item to="/pause">Ta pause ifra spill</b-nav-item>
            <b-nav-item to="/blokker">Blokker deg for spill</b-nav-item>

            <b-nav-item @click="handleLogout()">Logg ut</b-nav-item>

        </b-nav>

    </div>

</template>

<script>

export default {
    name: 'Nav',
    methods: {
        handleLogout() {
            this.$api.get(`/logout/`);

            this.$store.clear()
            this.$router.replace({ name: "login" });
        }
    },
    computed: {
        welcomePhrase: function() {

            return "Velkommen xxx";
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

@media only screen and (max-width: 576px) {
    div#nav {
        padding-left: 0 !important;
        padding-right: 0 !important;
        padding-top: 0 !important;
    }

    div#nav li a {
        padding-left: 8px !important;
        padding-right: 8px !important;
    }
}
</style>
